export const STUDENT_LIST = 'student_list';
export const STUDENT_LIST_SUCCESS = 'student_list_success';
export const ADD_STUDENT = 'add_new_student';
export const DELETE_STUDENT = 'delete_student';
export const EDIT_STUDENT = 'edit_student';
export const SET_LOADER = 'set_loader';
export const GET_STUDENT_DETAIL = 'get_student_detail';
export const GET_STUDENT_DETAIL_SUCCESS = 'get_student_detail_success';
export const GET_DROPDOWN_VALUES ='get_dropdown_values';
export const GET_DROPDOWN_VALUES_SUCCESS ='get_dropdown_values_success';